import { canLogin, getValidatedState } from './helpers';

const reducers = {
  loginPre2FASuccess: (state, payload) => {
    const {
      pre2faToken,
      code,
      phoneNumber,
      phoneNumberAdded,
      phoneOTPRequired,
      country,
    } = payload;
    const newState = {
      ...state,
      pre2faToken,
      code,
      phoneNumber,
      phoneNumberAdded,
      phoneOTPRequired,
      country,
    };

    // This step determines if email, 2fa or both OTPs will be verified in the Security Verification screen.
    if (code === 'email_code' || (code === 'phone_otp' && phoneOTPRequired)) {
      newState.verificationVariant = 'email';
    } else if (code === 'mfa_code_and_email_code') {
      newState.verificationVariant = 'both';
    } else if (code === 'mfa_code') {
      newState.verificationVariant = '2fa';
    }
    newState.showLoader = false;

    return newState;
  },

  loginPre2FAFailure: (state, payload) => {
    const { errorCode, errorContext } = payload;
    const newState = getValidatedState(state, {
      submit: true,
      errorCode,
      errorContext,
    });
    newState.showLoader = false;

    return newState;
  },

  submitClick: (state, payload) => {
    const { login, provider } = payload;
    const validatedState = getValidatedState(state, { submit: true });
    if (canLogin(validatedState)) {
      login(state);
      validatedState.showLoader = true;
    }
    const updatedState = {
      ...validatedState,
      oAuth: {
        ...state.oAuth,
        provider,
      },
    };
    return updatedState;
  },

  setEmailDomailCorrection: (state, payload) => {
    return {
      ...state,
      emailDomailCorrection: {
        suggestion: payload.suggestion,
        suggestedEmail: payload.suggestedEmail,
      },
    };
  },

  oAuthLoginInit: (state, payload) => {
    const { oAuthLogin, oAuthProvider } = payload;
    const updatedState = {
      ...state,
      oAuth: {
        ...state.oAuth,
        provider: oAuthProvider,
      },
    };
    oAuthLogin(updatedState);
    return updatedState;
  },

  oAuthLoginError: (state, payload) => {
    const { error } = payload;
    return {
      ...state,
      showOAuthBtnLoader: false,
      oAuth: {
        ...state.oAuth,
        ...error,
      },
    };
  },

  recaptchaError: state => {
    return {
      ...state,
      recaptchaError: true,
      showLoader: false,
    };
  },
};

export default reducers;
